import React, { useEffect, useState } from "react";
import "./CgTextArea.scss";

const CgTextArea = ({
  cols = 73,
  rows = 10,
  needBorder = false,
  onChangeCallBack = () => {},
  name,
  required = true,
  label = "NOTE",
  defaultValue,
  resetValue,
  renderCustomError, // boolean value
  customErrorMsg, // string
  onKeyChangeCallback = () => {},
}) => {
  const [error, setError] = useState("");
  const [value, setValue] = useState();

  useEffect(() => {
    if (resetValue && !defaultValue) {
      setValue("");
    } else {
      setValue(defaultValue);
    }
  }, [resetValue]);

  const handleBlur = () => {
    if (required && !value?.trim()) {
      setError(`${label} is required`);
    } else {
      setError("");
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setValue(value);
    setError("");
    onKeyChangeCallback(value);
    onChangeCallBack(value);
  };

  return (
    <>
      <div className={`textareaWrapper ${needBorder ? "needBorder" : ""}`}>
        <label>{label}</label>
        <textarea
          className={`form-control ${
            error && required ? "form-control error" : ""
          } ${renderCustomError ? "form-control error" : ""} `}
          name={name}
          onChange={handleChange}
          defaultValue={defaultValue}
          onBlur={handleBlur}
          cols={cols}
          rows={rows}
          value={value}
        />
      </div>
      {customErrorMsg && (
        <div className="commonCustomErrorMsg"> {customErrorMsg} </div>
      )}
    </>
  );
};

export default CgTextArea;
